import {
    UPDATE_COMPARISON_SURVEY_DATA
} from "../../../constants";
import { withType } from "../../../../utils/actionOperations";

export const UpdateComparionSurveyData = (payload, cb) => {
    return (dispatch) => {
        dispatch(withType(UPDATE_COMPARISON_SURVEY_DATA, payload));
    };
};